import { useIntl } from "react-intl";

const IPAllowlisting = () => {
    const intl = useIntl();

    const messages = {
        header: intl.formatMessage({
            id: "JiraServiceManagementPricingPage.features.IPAllowlisting.header",
            defaultMessage: "IP allowlisting"
        }),
        body: intl.formatMessage({
            id: "JiraServiceManagementPricingPage.features.IPAllowlisting.body",
            defaultMessage:
                "Help strengthen your team’s security by limiting your site access to trusted IP ranges."
        })
    };

    return (
        <>
            <h2>{messages.header}</h2>
            <p>{messages.body}</p>
        </>
    );
};

export default IPAllowlisting;
